import {TokenCredentials} from '../login/tokencredentials';

export class Vendor {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    vendorid: string;
	name1 : String;
	name2 : String;
	street : String;
	zip : String;
	city : String;
	state : String;
	country : String;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/vendor/vendor.ts